export function celdav2() {
  throw new Error('celdav2 es una directiva de preproceso y no debe llegar a ejecución')
}
